export class AssistanceForms {
  static initAll() {
    $(document).find("form.assistance-form").each(function(){
      new AssistanceForms(this)
    })

    $(document).find("form.batch-payment-form").each(function(){
      new BatchPaymentForm(this)
    })
  }

  constructor(form) {
    this.form = $(form)
    this.addReceiptBtn = this.form.find(".add-association")
    this.needTypeField = this.form.find("[name$='[need_type_id]']")
    this.landlordFields = this.form.find(".landlord-fields")
    this.assistanceToggle = this.form.find("[name$='[no_assistance]']")
    this.receiptList = this.form.find(".encounter-receipt-list")
    this.paymentDateField = this.form.find("[name$='[payment_date]']")
    this.fundingSrcField = this.form.find("[name$='[funding_source_id]']")
    this.checkField = this.form.find("[name$='[check_number]']")
    this.billFile = this.form.find("[name$='[bill_file]']")

    this.partialPaymentToggle = this.form.find("[name$='[partial_payment]']")
    this.partialPaymentFields = this.form.find(".partial-payment-fields")
    this.partialPaymentAmount = this.form.find("[name$='[client_paid_amount]']")
    this.partialPaymentPaid = this.form.find("[name$='[partial_payment_paid]']")

    this.addTriggers()
  }

  addTriggers() {
    const klass = this

    klass.addReceiptBtn[0].addEventListener("association.added", function(e){
      klass.syncPaymentFieldsWithAssistanceToggle()
    })

    klass.assistanceToggle.on("change", function(){
      klass.syncPaymentFieldsWithAssistanceToggle()
    }).trigger("change")

    klass.needTypeField.on("change", function(){
      if ($(this).val() == ""){
        klass.checkField.data("need-type", false)
        klass.landlordFields.hide()
      }
      else {
        klass.checkField.data("need-type", true)
        if ($(this).find(":selected").text() == "Rent")
          klass.landlordFields.show()
        else
          klass.landlordFields.hide()
      }
    }).trigger("change")

    klass.billFile.on("change", function(){
      klass.checkField.data("bill-file", true)
    })

    klass.partialPaymentToggle.on("change", function(){
      let partialFields = klass.partialPaymentAmount.add(klass.partialPaymentPaid).add(klass.receiptList.find("[name$='[receipt_file]']"))
      if (klass.partialPaymentToggle.is(":checked")) {
        klass.partialPaymentFields.show()
        partialFields.removeAttr("disabled")
        klass.checkField.data("partial-payment", true)
      }
      else {
        partialFields.attr("disabled", "disabled")
        klass.partialPaymentFields.hide()
        klass.checkField.data("partial-payment", false)
      }
    }).trigger("change")

    klass.receiptList.on("change", "[name$='[receipt_date]']", function(){
      if (klass.receiptList.find("[name$='[receipt_date]']").length > 0 && klass.receiptList.find("[name$='[receipt_date]']").filter(function(){ return $(this).val() === "" }).length <= 0)
        klass.partialPaymentPaid.prop("checked", true).trigger("change")
    })

    klass.partialPaymentPaid.on("change", function(){
      if ($(this).is(":checked"))
        klass.checkField.data("receipt-file", true)
      else
        klass.checkField.data("receipt-file", false)
    })

    klass.receiptList.on("click", ".remove-association", function(e){
      let trigger = $(e.currentTarget)
      let fields = trigger.closest(".encounter-receipt-fields")

      fields.slideUp(function(){
        if (fields.data("persisted")) {
          let idField     = fields.next("[name$='[id]']")
          let deleteField = idField.clone()

          deleteField.attr("name", function(idx, val) { return val.replace(/\[id\]/, "[_destroy]") })
          fields.replaceWith(deleteField)
        } else {
          fields.remove()
        }
      })
    })

    // let checkNumberRequirements = klass.needTypeField.add(klass.billFile).add(klass.partialPaymentToggle).add(klass.partialPaymentReceipt).add(klass.partialPaymentPaid)
    // checkNumberRequirements.on("change", function(){
    //   let check = klass.checkField
    //   if (!check.data("missing-intake-documents") && check.data("need-type") && check.data("bill-file") && (!check.data("partial-payment") || check.data("receipt-file"))) {
    //     check.removeAttr("disabled")
    //   } else {
    //     check.attr("disabled", "disabled")
    //   }
    // })
  }

  syncPaymentFieldsWithAssistanceToggle() {
    const paymentFields = this.paymentDateField.add(this.fundingSrcField).add(this.receiptList.find("[name$='[receipt_date]']"))
    if (this.assistanceToggle.is(":checked")) {
      paymentFields.attr("disabled", "disabled")
    } else {
      paymentFields.removeAttr("disabled")
    }
  }
}

class BatchPaymentForm {
  static disabledClass = "batch-row-disabled"

  constructor(form) {
    this.form = $(form)
    this.addTriggers()
  }

  addTriggers() {
    let klass = this

    this.form.find("[name$='[update]']").on("change", function(){
      let toggle = $(this)
      toggle.closest("tr").toggleClass(klass.constructor.disabledClass, !toggle.is(":checked"))
    })

    this.form.find("[name$='[payment_date]'], [name$='[check_number]']").on("focus", function(){
      let row = $(this).closest("tr")
      let toggle = row.find("[name$='[update]']")

      if (row.hasClass(klass.constructor.disabledClass))
        toggle.prop("checked", true).trigger("change")
    })
  }
}
